import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { CanonicalService } from 'src/app/services/canonical.service';
import { ConsentService, CookieConsent } from 'src/app/services/consent.service';

@Component({
    selector: 'app-cookies-policy',
    templateUrl: './cookies-policy.component.html',
    styleUrls: ['./cookies-policy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CookiesPolicyComponent implements OnInit, OnDestroy {

  consentLabel = '';
  private subscription?: Subscription;

  constructor(
    private title: Title,
    private metaTagService: Meta,
    private canonicalService: CanonicalService,
    private consentService: ConsentService
  ) { }

  ngOnInit(): void {
    this.canonicalService.setCanonicalURL();
    this.title.setTitle("Politique de cookies - promodeep.com");
    this.metaTagService.updateTag (
      { name:"description", content:"➤ Les cookies et traceurs utilisés par promodeep.com, leur finalité, leur durée et comment accepter, refuser ou modifier votre choix à tout moment."},
    );
    this.subscription = this.consentService.consent$.subscribe(consent => this.consentLabel = this.describe(consent));
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  openPreferences(): void {
    this.consentService.openPreferences();
  }

  // Page légale en français seulement (voir CLAUDE.md « i18n »)
  private describe(consent: CookieConsent | null): string {
    if (!consent) {
      return '';
    }
    const state = (granted: boolean) => granted ? 'acceptée' : 'refusée';
    // Pas de date quand le choix vient du message Google (conservée par Google)
    const date = consent.date ? ` (le ${new Date(consent.date).toLocaleDateString('fr-FR')})` : '';
    return `mesure d'audience ${state(consent.analytics)}, publicité ${state(consent.ads)}${date}.`;
  }

}
